import React from 'react';
import {Nav,Container,Navbar} from 'react-bootstrap';

export default function NavWind() {
    return (
        <>
  <Navbar className="resp-nav resp-nav-desk logoNavDdesktop containerfluid2" bg="dark" expand="lg">
  <Container fluid>

    <Navbar.Toggle aria-controls="navbarScroll" />
    <Navbar.Collapse id="navbarScroll">
      <Nav
        className="me-auto me-auto1 my-2 my-lg-0"
   
      >
         <Navbar.Brand href="/"><picture><source srcSet="/img/logo-nav-desk.webp" type="image/webp" /><img src="/img/logo-nav-desk.png" width="120" alt="logo" className='logoDesktop' /></picture></Navbar.Brand>
     
        <Nav.Link 
        // id="align-haztesocio"
         href="/garaje" className='letrasNav'>Vehículos de ocasión
                </Nav.Link>
                <Nav.Link href="/tasación"className='letrasNav'>Tasación</Nav.Link>
                <Nav.Link href="/financiación"className='letrasNav'>Financiación</Nav.Link>
                <Nav.Link href="/servicios"className='letrasNav'>Servicios</Nav.Link>
                <Nav.Link href="/contacto"className='letrasNav'>Contacto</Nav.Link>
                <Nav.Link href="/faq"className='letrasNav'>FAQ</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Container>
</Navbar>
</>
    )
}